import { lang } from './i18n.ts';
import type { Lang } from './i18n.ts';

const loc = (l: Lang): string => (l === 'hi' ? 'hi-IN' : 'en-IN');

// ₹4,500 and ₹1,20,000: Indian digit grouping in both languages, Latin digits as on UPI apps.
export function fmtPrice(n: number, l: Lang = lang()): string {
  if (n === 0) return l === 'hi' ? 'मुफ़्त' : 'Free';
  return `₹${new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(n)}`;
}

export function fmtDate(ms: number, l: Lang = lang()): string {
  return new Intl.DateTimeFormat(loc(l), { day: 'numeric', month: 'short' }).format(ms);
}

export function fmtDateTime(ms: number, l: Lang = lang()): string {
  return new Intl.DateTimeFormat(loc(l), { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }).format(ms);
}

export function fmtTime(ms: number): string {
  return new Intl.DateTimeFormat('en-IN', { hour: '2-digit', minute: '2-digit', hour12: false }).format(ms);
}

export function fmtAgo(ms: number, now: number, l: Lang = lang()): string {
  const rtf = new Intl.RelativeTimeFormat(loc(l), { numeric: 'auto' });
  const s = Math.round((ms - now) / 1000);
  const abs = Math.abs(s);
  if (abs < 60) return rtf.format(0, 'minute');
  if (abs < 3600) return rtf.format(Math.round(s / 60), 'minute');
  if (abs < 86400) return rtf.format(Math.round(s / 3600), 'hour');
  return rtf.format(Math.round(s / 86400), 'day');
}
